import React from 'react';
import { ShieldCheck, Truck, PenTool } from 'lucide-react';
export const TrustBar = () => {
  const features = [{
    icon: ShieldCheck,
    text: 'Authenticated & Graded'
  }, {
    icon: Truck,
    text: 'Fast Insured Shipping'
  }, {
    icon: PenTool,
    text: 'Verified Autographs'
  }];
  return <div className="bg-ink text-white py-4 border-y-4 border-ink shadow-[0px_4px_0px_0px_#1A1A1A] relative z-20" data-id="element-144">
      <div className="container mx-auto px-4" data-id="element-145">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-146">
          {features.map((feature, idx) => <div key={idx} className="flex items-center justify-center space-x-2" data-id="element-147">
              <feature.icon className="w-5 h-5 text-scarlet flex-shrink-0" data-id="element-148" />
              <span className="text-xs md:text-sm font-bold uppercase tracking-wider text-center" data-id="element-149">
                {feature.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};